import { Context } from "Context";
import { useCallback, useContext } from "react";
import { trackLink } from "utils/analyticsFramework";
import appConfig from "config.json";

let clickLocked = false;

export const resetClickLock = () => {
	clickLocked = false;
};

const AnalyticsWrapper = ({
	analyticsLinkId,
	children,
	pageTransitionLink = true,
}) => {
	const {
		config: { brand },
	} = useContext(Context);

	const trackAnalyticsWrapperLink = useCallback(
		(userInteraction = "HOVER") => {
			const trackLinkData = {
				linkId: `${analyticsLinkId}_${userInteraction}`,
			};
			if (appConfig.sendPageTransitionLinkBrands.includes(brand)) {
				trackLinkData.pageTransitionLink = pageTransitionLink;
			}
			trackLink(trackLinkData);
		},
		[analyticsLinkId, brand, pageTransitionLink]
	);

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a
			name={analyticsLinkId ? `&lid=${analyticsLinkId}` : null}
			tabIndex={-1}
			style={{ display: "contents" }}
			onClick={() => {
				if (analyticsLinkId) {
					if (pageTransitionLink) clickLocked = true;
					trackAnalyticsWrapperLink("CLICK");
				}
			}}
			onMouseEnter={() => {
				if (analyticsLinkId && !clickLocked) {
					trackAnalyticsWrapperLink();
				}
			}}
			className="syndicated-analytics-wrapper"
		>
			{children}
		</a>
	);
};

export default AnalyticsWrapper;
